import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { CommandFactory } from '../../background/commands/CommandFactory';
import LoadSpinner from '../primitives/LoadSpinner';
import PriceAlertsVirtualList from './PriceAlertsVirtualList';
import { SendEventToGoogleAnalytics } from '../../background/storeListener/googleAnalyticsListener';
import { setMarkForFutureFetch } from '../../background/reducers/priceAlertsReducer';

const PriceAlerts = ({
    isBottomPanelPinned, subHeaderColor, systemColor, linkColor, isActive
}) => {
    const { priceAlerts = {}, getAllCommand, markForFutureFetch = true, continuationToken = null, knownSeq = null } = useSelector((state) => (state.account?.priceAlerts || {}), shallowEqual);
    const [isLoading, setIsLoading] = useState(true);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    
    // Dispatch tab activity status when component mounts or when isActive changes
    useEffect(() => {
        dispatch({
            type: 'price-alerts-page-activity',
            payload: { isActive: true }
        });
        
        return () => {
            dispatch({
                type: 'price-alerts-page-activity',
                payload: { isActive: false }
            });
        };
    }, [dispatch]);

    useEffect(() => {
        const fetchData = async () => {
            // Only fetch data if we have a command and either markForFutureFetch is true
            // or we haven't fetched data yet (isGetAllRequested is false)
            if (getAllCommand && markForFutureFetch) {
                setIsLoading(true);
                try {
                    const command = CommandFactory.createCommand(getAllCommand);
                    
                    // Create the request object with the continuation token
                    const userInput = {
                            ContinuationToken: continuationToken,
                            KnownSeq: knownSeq
                    };
                    
                    // Execute the command with the request body
                    await command.execute(userInput);
                    dispatch(setMarkForFutureFetch(false));
                    SendEventToGoogleAnalytics('price_alerts', 'fetch', 'success');
                } catch (err) {
                    console.error('Error fetching price alerts:', err);
                    SendEventToGoogleAnalytics('price_alerts', 'fetch', 'error');
                } finally {
                    setIsLoading(false);
                }
            } else {
                setIsLoading(false);
            }
        };
        
        fetchData();
    }, [getAllCommand, markForFutureFetch, dispatch]);


    // Function to handle deleting a price alert
    const handleDeletePriceAlert = async (alertId) => {
        if (!alertId) return;
        
        try {
            const deleteCommand = {
                cmdId: 'STD.CMD.Server',
                staticParams: {
                    postUrl: 'api/priceAlert/deleteAccountPriceAlert'
                }
            };
            
            const userInput = {
                PriceAlertId: alertId,
            };
            
            const command = CommandFactory.createCommand(deleteCommand);
            const result = await command.execute(userInput);
            
            if (result && result.IsSuccess) {
                SendEventToGoogleAnalytics('price_alerts', 'delete', 'success');
            } else {
                console.error('Failed to delete price alert');
                SendEventToGoogleAnalytics('price_alerts', 'delete', 'error');
            }
        } catch (err) {
            console.error('Error deleting price alert:', err);
            SendEventToGoogleAnalytics('price_alerts', 'delete', 'error');
        }
    };

    if (isLoading) {
        return <LoadSpinner isBottom />;
    }

    const priceAlertsToRender = Object.values(priceAlerts);

    return (
        <div>
            <div className='closed-table__wrapper'>
                <PriceAlertsVirtualList
                    priceAlertsToRender={priceAlertsToRender}
                    isBottomPanelPinned={isBottomPanelPinned}
                    subHeaderColor={subHeaderColor}
                    systemColor={systemColor}
                    linkColor={linkColor}
                    onDeleteAlert={handleDeletePriceAlert}
                />
            </div>
        </div>
    );
};

export default PriceAlerts;
